export const CONTACTS_DUCK = 'contacts'

export const CONTACTS_UPDATE_LIST = 'contacts/UPDATE_LIST'
export const CONTACTS_UPDATE_STATUS = 'contacts/UPDATE_STATE'
export const CONTACTS_UPDATE_SORTING = 'contacts/UPDATE_SORTING'
export const CONTACTS_ADD_CONTACT = 'contacts/CONTACTS_ADD_CONTACT'
